import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import _ from 'lodash';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {RECOURSE, NON_RECOURSE} from 'constants/recourseTypes';
import {
  AlignedGrid, QuoteComparisonExpansionPanel, createLoanGridElements, createLoanGridLabel,
  createLoanGridElementsWithRenderer,
  createMoneyLoanGridElements,
  createPeriodLoanGridElements,
  RightAlignedDiv,
  QuoteComparisonExpansionSummary,QuoteComparisonExpansionPanelDetails,
  createMultiLineStringLoanGridElements
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';

class Recourse extends Component {
  state = {
    expanded:true
  }
  renderRate = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatRate(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }

  renderPlainProperty = (property) =>{
    return (loan) => {
      let value = loan[property];
      return value;
    }
  }
  renderMoney = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatMoney(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }
  renderRecourse = (loan) => {
    if(_.get(loan, 'recourse')){
      return _.get(loan, 'recourse');
    }
    let val = loan['recourseType'];
    if(val === RECOURSE)
      return 'Yes';
    if(val === NON_RECOURSE)
      return 'No';
    return '\u2014';
  }

  renderBoolean = (property) => {
    return (loan) => {
      let value = loan[property];
      if(value===null)return '\u2014';
      if(value == 1 || value==true) return "Yes";
      if(value == 0 || value==false) return "No"
      return `\u2014`;
    }
  }


  render() {
    const { loans,isCombined } = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} expanded={expanded}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Recourse")}
            {expanded && createLoanGridElementsWithRenderer(loans, this.renderRecourse,'\u2014',isCombined)}  
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {createLoanGridLabel("Recourse Amount")}
            {createLoanGridElementsWithRenderer(loans, this.renderRate('loanRecourseAmount'),'\u2014', isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Burndown")}
            {createLoanGridElementsWithRenderer(loans, this.renderBoolean('loanRecourseBurndown'), '\u2014', isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Recourse Note")}
            {createMultiLineStringLoanGridElements(loans, 'loanRecourseNotes', '\u2014',isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default Recourse;